// src/merch/flags.js
//
// Friendly, client-side heads-up only. The server (supabase/functions/
// _shared/merch.ts) runs the real auto-flags; a human reviews every order.
// Only distinctive pro/brand names here — everyday words like "Jets" or
// "Kings" are real minor-hockey team names and shouldn't nag kids.

const TERMS = [
  "nhl", "stanley cup", "maple leafs", "canadiens", "habs", "oilers", "canucks", "bruins",
  "blackhawks", "penguins", "red wings", "golden knights", "blue jackets", "hurricanes",
  "avalanche", "islanders", "capitals", "predators", "kraken",
  "nike", "adidas", "reebok", "under armour", "ccm", "bauer", "disney", "marvel", "pokemon", "fortnite", "minecraft",
];

export function trademarkHits(texts = []) {
  const all = texts.join(" \n ").toLowerCase();
  return TERMS.filter((t) => new RegExp(`\\b${t.replace(/\s/g, "\\s?")}\\b`).test(all));
}
